import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { PullSheetService } from "./pull-sheet.service";

import { Observable, of, catchError, finalize } from "rxjs";
import { IPullSheetGetDTO } from "./models";
import { TimeUtil } from "src/app/shared/services/time-util.service";
import { LoaderService } from "src/app/shared/components/loader/loader.service";

export const pullSheetResolver: ResolveFn<
  Observable<IPullSheetGetDTO[]>
> = () => {
  const pullSheetService = inject(PullSheetService);
  const timeUtil = inject(TimeUtil);
  const loaderService = inject(LoaderService);
  loaderService.show();
  return pullSheetService
    .get({
      pullDate: timeUtil.formatDateLocalYYYYMMDD(new Date()),
    })
    .pipe(
      catchError(() => of([])),
      finalize(() => {
        loaderService.hide();
      })
    );
};
